import { Icon as DesignSystemIcon, type IconProps as DesignSystemIconProps } from "@/design-system/Icon";

export type IconProps = DesignSystemIconProps;
export type IconComponent = React.ReactElement<Omit<IconProps, "name">>;

// Generated icon wrappers still import this path. New design-system code uses its owning Icon module directly.
export function Icon(props: IconProps): React.ReactNode {
  return <DesignSystemIcon {...props} />;
}
